import { t } from "@lingui/macro";

export const getButtonText = (
  hasPaymentCardOnFile: boolean,
  requiresPaymentCardOnFile: boolean,
  requiresPrePayment: boolean,
  clubSupportsPrivateBookings: boolean,
  isLessonBooking: boolean = false,
  isRequestBooking: boolean = false,
  totalDueAfterCredits: number = 0,
  seriesRequestCount: number = 1
) => {
  if (isRequestBooking) {
    return seriesRequestCount > 1
      ? t`Submit ${seriesRequestCount} Requests`
      : t`Submit Request`;
  }
  if (
    !hasPaymentCardOnFile &&
    ((requiresPrePayment && totalDueAfterCredits !== 0) ||
      requiresPaymentCardOnFile)
  ) {
    return t`Add Payment Method`;
  }
  if (
    requiresPrePayment &&
    hasPaymentCardOnFile &&
    totalDueAfterCredits !== 0
  ) {
    return isLessonBooking ? t`Complete Booking` : t`Finish And Pay`;
  }
  if (clubSupportsPrivateBookings) {
    return t`Complete Booking`;
  }
  return t`Confirm Booking`;
};
